import type { FaireProductEntity } from "../../entity_types/product";

export const p_352fdmeyvv: FaireProductEntity = {
  token: "p_352fdmeyvv",
  type: "product",
  name: "SMOCKED CHEST FLORAL PRINTED MAXI DRESS",
  brandToken: "b_baiv9uj7",
  brandName: "STACCATO",
  imageUrl:
    "https://cdn.faire.com/fastly/1a1cacb1b1e4a758e76bfb7388b8211218e79d1cf102c804154da245368152b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21f296038f9a56732ed42a0cec1f9ab43f41b1377bfc44fee460c5158fc1e51b.jpeg",
    "https://cdn.faire.com/fastly/45cc9f876111a018aef8e22bbde4c36f92b8e7659d16fdbfcbdf78d561e4a102.jpeg",
    "https://cdn.faire.com/fastly/72ded4dd991287f59a568d8e7e10fb3a80fb5d3dcb81c9f616bc0511ec72ed98.jpeg",
  ],
  priceDollars: 16.75,
  description:
    "COLLARED V-NECK, SMOCKED CHEST, PUFF HALF SLEEVES, FLORAL PRINTED MAXI DRESS WITH SIDE POCKETS",
  tags: [],
  msrpDollars: 45.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:45.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
